export async function loadCampaignMarkerIcons(map: any): Promise<void> {
  const levels = ['low', 'medlow', 'medhigh', 'high']
  await Promise.all(
    levels.map(
      (level) =>
        new Promise<void>((resolve) => {
          const id = `campaign-marker-${level}`
          const url = `/assets/img/verticals/campaign/map/marker-${level}@2x.png`
          if (map.hasImage(id)) return resolve()
          map.loadImage(url, (err, image) => {
            if (!err && image) {
              map.addImage(id, image, { pixelRatio: 2 })
            }
            resolve()
          })
        }),
    ),
  )
}

export function buildQuartileMarkerExpression(
  pois: any[],
  indicator: string,
): any[] | null {
  const values = pois
    .map((p) => p[indicator])
    .filter((v) => v != null)
    .sort((a, b) => a - b)

  if (!values.length) return null

  const q1 = values[Math.floor(values.length * 0.25)] || 0
  const q2 = values[Math.floor(values.length * 0.5)] || 0
  const q3 = values[Math.floor(values.length * 0.75)] || 0

  return [
    'step',
    ['get', indicator],
    'campaign-marker-low',
    q1,
    'campaign-marker-medlow',
    q2,
    'campaign-marker-medhigh',
    q3,
    'campaign-marker-high',
  ]
}
